import { render, staticRenderFns } from "./ModalRemoveInstructor.vue?vue&type=template&id=6081324b&scoped=true&"
import script from "./ModalRemoveInstructor.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081324b",
  null
  
)

export default component.exports